<template>
	<div>
        <q-table
            ref="table"
            :data="users"
            :columns="columns_users"
            row-key="user_id"
            :pagination.sync="pagination"
            @request="requestUserDrills"
            :loading="loading"
            :no-data-label="$t('no_data_avaliable')"
            :no-results-label="$t('no_results_found')"
            :loading-label="$t('loading_data')"
            :rows-per-page-label="$t('items_per_page')"
            :rows-per-page-options="[5,10,50,100]"
            :filter=filter_users
            binary-state-sort
            class="q-mt-lg"
            >

            <template slot="top" slot-scope="props" :props="props">
                <q-search v-model="filter_users" icon="fas fa-search" :placeholder="$t('search')" :debounce="500" />
            </template>

            <q-tr slot="header" slot-scope="props" :props="props">
                <q-th v-for="col in props.cols" :key="col.name" :props="props">
                    {{ $t(col.label) }}
                </q-th>
            </q-tr>

            <template slot="body" slot-scope="props">
                <q-tr :props="props" class="cursor-pointer" @click.native="showDrillUsersResult(props.row)">
                    <q-td key="full_name" :props="props">
                        {{ props.row.full_name }}
                    </q-td>

                    <q-td key="email" :props="props">
                        {{ props.row.email }}
                    </q-td>

                    <q-td key="result_date" :props="props">
                        {{ fDate(props.row.result_date) }}
                    </q-td>

                    <q-td key="qty_correct_answers" :props="props">
                        {{ props.row.qty_correct_answers }}
                    </q-td>

                    <q-td key="qty_wrong_answers" :props="props">
                        {{ props.row.qty_wrong_answers }}
                    </q-td>

                    <q-td key="status" :props="props" auto-width>
                        <q-chip small :icon="getIconStatusUser(props.row)" :color="getColorStatusUser(props.row)" class="full-width text-center" v-if="props.row.status || props.row.expired">
                            {{ $t(getTextStatusUser(props.row)) }}
                        </q-chip>
                    </q-td>
                </q-tr>
            </template>
        </q-table>

        <q-modal v-model="show_drill_users_result" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh'}">
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense @click="show_drill_users_result = false" icon="fas fa-times" />
                    <q-toolbar-title>
                        {{ drill.title }}
                    </q-toolbar-title>
                </q-toolbar>

                <div class="layout-padding">
                    <div class="row gutter-sm justify-end question-list">
                        <div class="col-xs-12 col-sm-12" v-for="(question, index) in drill_result" :key="`drill-${index}`">
                            <span :class="getQuestionClass(index, question)">
                                {{ index + 1 }}) <span v-html="question.title"></span>
                            </span>

                            <q-field :error="question.error" error-label="_">
                                <q-option-group
                                    type="radio"
                                    v-model="question.user_answer_id"
                                    :options="question.answers"
                                    class="questions q-mt-xs"
                                    :class="question.is_correct ? 'checkbox-hit' : question.is_correct == null ? '' : 'checkbox-error'"
                                    @input="question.error = false"
                                    readonly
                                />
                            </q-field>
                        </div>
                    </div>
                </div>
            </q-modal-layout>
        </q-modal>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'

export default {

    props: ['load', 'id', 'status', 'title'],

    data() {
        return {
            pagination: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: null,
                descending: false,
                sortBy: null
            },
            columns_drills: [
                {
                    name: 'full_name',
                    required: true,
                    label: 'name',
                    align: 'left',
                    field: 'full_name',
                    sortable: true,
                },
                {
                    name: 'email',
                    required: true,
                    label: 'email',
                    align: 'left',
                    field: 'email',
                    sortable: true,
                },
                {
                    name: 'qty_correct_answers',
                    required: true,
                    label: 'questions',
                    align: 'left',
                    field: 'qty_correct_answers',
                    sortable: true,
                },
                {
                    name: 'qty_wrong_answers',
                    required: true,
                    label: 'wrong_answers',
                    align: 'left',
                    field: 'qty_wrong_answers',
                    sortable: true,
                },
                {
                    name: 'status',
                    required: true,
                    label: 'status',
                    align: 'left',
                    field: 'status',
                    sortable: true,
                },
                {
                    name: 'actions',
                    required: true,
                    label: '',
                    align: 'left',
                    field: 'actions',
                    sortable: false,
                }
            ],
            columns_users: [
                {
                    name: 'full_name',
                    required: true,
                    label: 'name',
                    align: 'left',
                    field: 'full_name',
                    sortable: true,
                },
                {
                    name: 'email',
                    required: true,
                    label: 'email',
                    align: 'left',
                    field: 'email',
                    sortable: true,
                },
                {
                    name: 'result_date',
                    required: true,
                    label: 'date',
                    align: 'left',
                    field: 'result_date',
                    sortable: true,
                },
                {
                    name: 'qty_correct_answers',
                    required: true,
                    label: 'correct_answers',
                    align: 'left',
                    field: 'qty_correct_answers',
                    sortable: true,
                },
                {
                    name: 'qty_wrong_answers',
                    required: true,
                    label: 'wrong_answers',
                    align: 'left',
                    field: 'qty_wrong_answers',
                    sortable: true,
                },
                {
                    name: 'status',
                    required: true,
                    label: 'status',
                    align: 'left',
                    field: 'status',
                    sortable: true,
                }
            ],
            drills: [],
            users: [],
            drill: {},
            drill_result: [],
            drill_results: [],
            show_drill_users: false,
            show_drill_users_result: false,
            show_drill_results: false,
            loading: false,
            filter_users: ''
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            id_user_language_selected: 'common/id_user_language_selected',
            num_rows: 'datatable/num_rows',
            id_user_client_selected: 'common/id_user_client_selected',
            user_client_module_items: 'common/user_client_module_items',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '80vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        },

		reportsPermission() {
            let obj = this.user_client_module_items.find((obj) => { return obj.id === this.id_user_client_selected })
            if (obj) {
                let item = obj.module_items.find((obj) => {
                    return obj.slug === "reports"
                })
                if(item){
                    return item.permission
                }
            }
            return false
        },
    },

    methods: {
        requestUserDrills({ pagination }) {
            this.loading = true
            this.pagination = pagination

            let order = pagination.descending ? '-' : ''
            let order_by = pagination.sortBy ? order + pagination.sortBy : ''

            let data = {
                "page_size": this.pagination.rowsPerPage,
                "page": this.pagination.page,
                "ordering": order_by,
                "search": this.filter_users
            }

            this.savePaginationUsers()

            this.$axios.get(`/admin_drills/drills/${this.id}/drill_user_results/?${this.$qs.stringify(data)}`, this.getHeader)
            .then(response => {
                this.pagination.rowsNumber = response.data.count

                if (response.data.results.length) {
                    this.users = response.data.results.map(e => {
                        return { ...e }
                    })
                }

            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.loading = false
            })
        },

        showDrillUsersResult(row) {
            if (row.result_id) {
                this.$q.loading.show()

                this.$axios.get(`/admin_drills/drills/${this.id}/drill_user_results/user_test_result/?attempt_id=${row.result_id}`, this.getHeader)
                .then(response => {

                    if (response.data.questions.length) {
                        this.drill_result = response.data.questions.map(e => {
                            return {
                                ...e,
                                answers: e.drill_question_answers.map(g => {
                                    return { ...g, label: this.fixAnswerLabel(g.title), value: g.id }
                                }),
                                user_answer_id: parseInt(e.user_answer_id)
                            }
                        })
                    }

                    this.show_drill_users_result = true
                })
                .catch(e => {
                    console.log(e)
                })
                .finally(() => {
                    this.$q.loading.hide()
                })
            }
        },

        fixAnswerLabel(answer) {
            const colorReg = /color:[a-zA-Z]+"|;\\ncolor:[a-zA-Z]+"|color:[a-zA-Z]+;|color:[a-zA-Z]+'/
            const colorReg2 = /color: rgb\([^)]*\);/

            if (colorReg.test(answer)) {
                const fixedAnswer = answer.replace(colorReg, '"')
                return fixedAnswer
            } else if (colorReg2.test(answer)) {
                const fixedAnswer = answer.replace(colorReg2, ';')
                return fixedAnswer
            }
            return answer
        },

        getQuestionClass(index, question) {
            let return_class = ''
            if (index != 0) return_class += 'q-mt-md'
            if (question.error) return_class += ' text-negative'
            return return_class
        },

        fDate(d) {
            if (d) {
                let format = ''

                switch(this.id_user_language_selected) {
                    case 1:
                    case 3: format = 'DD/MM/YYYY HH:mm:ss'
                    break
                    default: format = 'MM-DD-YYYY HH:mm:ss'
                    break
                }

                return date.formatDate(d, format)
            }
        },

        getTextStatusUser({status, expired, ...rest}) {
            if(expired) return 'expired'
            if (status === 1) return 'approved'
            else if (status === 2) return 'reproved'
            else if (status === 3) return 'blocked'
            else if (status === 4) return 'restart'
            else if (status === 5) return 'improved'
        },

        getColorStatusUser({status, expired}) {
            if (expired) return 'negative'
            if (status === 1) return 'positive'
            else if (status === 2) return 'negative'
            else if (status === 3) return 'negative'
            else if (status === 4) return 'info'
            else if (status === 5) return 'positive'
        },

        getIconStatusUser({status, expired}) {
            if (expired) return 'fa fa-times'
            if (status === 1) return 'fas fa-check'
            else if (status === 2) return 'fas fa-times'
            else if (status === 3) return 'fas fa-times'
            else if (status === 4) return 'far fa-clock'
            else if (status === 5) return 'fas fa-check'
        },

        savePaginationUsers() {
            this.$store.dispatch('datatable/SET_NUM_ROWS', [this.pagination.rowsPerPage])
        },

        loadPagination() {
            this.pagination.rowsPerPage = this.num_rows
        }
    },

    watch: {
        load: function() {
            if (this.load) {
                this.requestUserDrills({ pagination: this.pagination })
            }
        },

        num_rows: {
            handler: function(newValue) {
                this.loadPagination()
            },
            deep: true
        }
    },

    created() {
        this.loadPagination()

        this.requestUserDrills({ pagination: this.pagination })
    }
}
</script>

<style>

</style>
